import { useState, useEffect } from 'react'
import { TextField, Grid, Box, Typography } from '@mui/material'

function AddressInformation ({ onValidationChange, showErrors, formData, onFormDataChange }) {
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    onFormDataChange({ [name]: value })
  }

  useEffect(() => {
    const newErrors = {}
    if (!formData.address.trim()) newErrors.address = 'Address is required'
    if (!formData.suburb.trim()) newErrors.suburb = 'Suburb is required'
    if (!formData.city.trim()) newErrors.city = 'City is required'
    setErrors(newErrors)
    onValidationChange(Object.keys(newErrors).length === 0)
  }, [formData, onValidationChange])

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6'>Address Information</Typography>
      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            label='Address'
            name='address'
            variant='outlined'
            value={formData.address}
            onChange={handleChange}
            error={!!errors.address && showErrors}
            helperText={showErrors ? errors.address : ''}
            required
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            label='Address 2'
            name='address2'
            variant='outlined'
            value={formData.address2}
            onChange={handleChange}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label='Suburb'
            name='suburb'
            variant='outlined'
            value={formData.suburb}
            onChange={handleChange}
            error={!!errors.suburb && showErrors}
            helperText={showErrors ? errors.suburb : ''}
            required
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label='City'
            name='city'
            variant='outlined'
            value={formData.city}
            onChange={handleChange}
            error={!!errors.city && showErrors}
            helperText={showErrors ? errors.city : ''}
            required
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            label='Postcode'
            name='postcode'
            variant='outlined'
            value={formData.postcode}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default AddressInformation
